/* eslint-disable no-shadow */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { useEffect, useState } from 'react'

import LabelWrapper from '../LabelWrapper'

const styles = theme => ({
  root: {
    '--ck-color-text': `var(--gameday-buttons-actionButtonColor, ${theme.buttons.actionButtonColor})`,
    '--ck-color-base-background': `var(--gameday-inputField-richTextBg, ${theme.inputField.richTextBg})`,
    '--ck-color-base-border': `var(--gameday-borders-borderColor, ${theme.borders.borderColor})`,
    '--ck-color-dropdown-panel-border': `var(--gameday-borders-borderColor, ${theme.borders.borderColor})`,
    '--ck-color-dropdown-panel-background': `var(--gameday-buttons-actionButtonBg, ${theme.buttons.actionButtonBg})`,
    '--ck-color-toolbar-border': `var(--gameday-borders-borderColor, ${theme.borders.borderColor})`,
    '--ck-color-toolbar-background': `var(--gameday-buttons-actionButtonBg, ${theme.buttons.actionButtonBg})`,
    '--ck-color-button-default-hover-background': `var(--gameday-buttons-actionButtonBgHover, ${theme.buttons.actionButtonBgHover})`,
    '--ck-color-button-default-active-background': `var(--gameday-buttons-actionButtonBgHover, ${theme.buttons.actionButtonBgHover})`,
    '--ck-color-button-on-background': `var(--gameday-buttons-actionButtonBgHover, ${theme.buttons.actionButtonBgHover})`,
    '--ck-color-button-on-hover-background': `var(--gameday-buttons-actionButtonBgHover, ${theme.buttons.actionButtonBgHover})`,
    '--ck-color-button-on-active-background': `var(--gameday-buttons-actionButtonBgHover, ${theme.buttons.actionButtonBgHover})`,
    '--ck-color-list-background': `var(--gameday-buttons-actionButtonBg, ${theme.buttons.actionButtonBg})`,
    '--ck-color-list-button-on-background': `var(--gameday-buttons-actionButtonBgHover, ${theme.buttons.actionButtonBgHover})`,
    '--ck-color-list-button-on-background-focus': `var(--gameday-buttons-actionButtonBg, ${theme.buttons.actionButtonBg})`,
    '--ck-color-list-button-on-text': theme.body.textColor,
    '--ck-color-list-button-hover-background': `var(--gameday-buttons-actionButtonBgHover, ${theme.buttons.actionButtonBgHover})`,
    '--ck-border-radius': '4px',
    '--ck-font-size-base': '13px',
    '--ck-icon-size': '15px',
    '--ck-focus-ring': theme.borders.default,
    '--ck-spacing-small': '4px',
    '--ck-spacing-tiny': '2px',
    '--ck-ui-component-min-height': '24px',
    [`& .ck.ck-button:not(.ck-disabled):active,
      & a.ck.ck-button:not(.ck-disabled):active,
      & .ck.ck-button.ck-disabled:active,
      & .ck.ck-button.ck-disabled:focus,
      & a.ck.ck-button.ck-disabled:active,
      & a.ck.ck-button.ck-disabled:focus`]: {
      boxShadow: 'none',
      borderColor: `var(--gameday-buttons-actionButtonBgHover, ${theme.buttons.actionButtonBgHover})`,
    },
    '& .ck.ck-editor__editable.ck-focused, & .ck.ck-dropdown__panel': {
      borderColor: theme.colors.teal,
      boxShadow: 'none',
    },
    '& .ck.ck-toolbar': {
      border: 'none',
      marginBottom: 5,
    },
    '& .ck.ck-editor__main': {
      color: `var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`,
    },
    [`& .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
      & .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners,
      & .ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,
      & .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners`]: {
      borderRadius: '4px',
    },
    '& .ck.ck-toolbar .ck.ck-toolbar__separator': {
      background: `var(--gameday-mainNav-topBarSeperatorColor, ${theme.mainNav.topBarSeperatorColor})`,
    },
    '& .ck.ck-editor__editable_inline': {
      fontSize: 14,
      padding: '0 12px',
    },
    [`& .ck.ck-dropdown__button,
      & .ck.ck-list__item > button,
      & .ck.ck-button.ck-on,
      & a.ck.ck-button.ck-on`]: {
      color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
    },
    '& .ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label': {
      lineHeight: 'normal',
    },
    '& .ck.ck-button, & a.ck.ck-button': {
      display: 'flex',
    },
  },
})

function RichText(props) {
  const {
    basic,
    classes,
    className,
    customCol,
    customMargin,
    customPadding,
    customWidth,
    data,
    disabled,
    disableEnter,
    errorText,
    fullWidth,
    helperText,
    id,
    isLabelInline,
    isRequired,
    isToolTip,
    justify,
    label,
    multipleFields,
    noMobile,
    notWrapper,
    noWrap,
    onBlur,
    onChange,
    onFocus,
    onInit,
    readOnly,
    showActionLink,
    spacing,
    toolTipIcon,
    toolTipIconColor,
    toolTipIconSize,
    toolTipPosition,
    toolTipText,
    withBorder,
    withDivider,
    ...rest
  } = props
  const [editorLib, setEditorLib] = useState(null)
  const [editorBuild, setEditorBuild] = useState(null)

  useEffect(() => {
    let isMounted = true

    if (typeof window === 'undefined') {
      return () => {
        isMounted = false
      }
    }

    Promise.all([import('@ckeditor/ckeditor5-react'), import('@ckeditor/ckeditor5-build-classic')])
      .then(([editorModule, buildModule]) => {
        if (!isMounted) return
        setEditorLib(() => editorModule.default || editorModule)
        setEditorBuild(() => buildModule.default || buildModule)
      })
      .catch(() => {})

    return () => {
      isMounted = false
    }
  }, [])

  const extraItems = !basic
    ? [
        // 'imageUpload', Disabling until we have a solution
        'insertTable',
        'mediaEmbed',
      ]
    : []

  const handleChange = (_, editor) => {
    const data = editor.getData()
    onChange(data)
  }

  const CKEditorComponent = editorLib

  return (
    <LabelWrapper
      className={cn({ disabled, errorText, readOnly }, classes.root, className)}
      customCol={customCol}
      customMargin={customMargin}
      customPadding={customPadding}
      customWidth={customWidth}
      disabled={disabled}
      errorText={errorText}
      fullWidth={fullWidth}
      helperText={helperText}
      id={id}
      isLabelInline={isLabelInline}
      isRequired={isRequired}
      isToolTip={isToolTip}
      justify={justify}
      label={label}
      multipleFields={multipleFields}
      noMobile={noMobile}
      notWrapper={notWrapper}
      noWrap={noWrap}
      showActionLink={showActionLink}
      spacing={spacing}
      toolTipIcon={toolTipIcon}
      toolTipIconColor={toolTipIconColor}
      toolTipIconSize={toolTipIconSize}
      toolTipPosition={toolTipPosition}
      toolTipText={toolTipText}
      withBorder={withBorder}
      withDivider={withDivider}
    >
      <div style={customWidth && { maxWidth: customWidth }}>
        {CKEditorComponent && editorBuild ? (
          <CKEditorComponent
            data={data}
            disabled={disabled || readOnly}
            editor={editorBuild}
            onBlur={onBlur}
            onChange={(_, editor) => handleChange(_, editor)}
            onFocus={onFocus}
            onInit={editor => {
              if (disableEnter) {
                editor.editing.view.document.on(
                  'enter',
                  (evt, data) => {
                    data.stopPropagation()
                    data.preventDefault()
                    evt.stop()
                  },
                  { priority: 'highest' }
                )
              }
            }}
            config={{
              toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                ...extraItems,
                'undo',
                'redo',
              ],
              blockFillerMode: 'br',
              link: {
                defaultProtocol: 'https://',
                decorators: {
                  isExternal: {
                    mode: 'automatic',
                    // biome-ignore lint/correctness/noUnusedVariables: TODO
                    callback: url => true,
                    label: 'Open in a new tab',
                    attributes: {
                      target: '_blank',
                      rel: 'noopener noreferrer',
                      class: 'rich-text-link',
                    },
                  },
                },
              },
            }}
            {...rest}
          />
        ) : null}
      </div>
    </LabelWrapper>
  )
}

RichText.defaultProps = {
  customWidth: null,
  notWrapper: true,
  readOnly: false,
  withBorder: true,
}

const RichTextComponent = withStyles(styles)(RichText)
RichTextComponent.displayName = 'RichText'
export default RichTextComponent
